import { bsc, bscTestnet, holesky, polygon, sepolia } from "viem/chains";

export const environment = {
    production: false,
    CONTRACT_ADDRESS:'0xA1781A0cdc1be3509b5F2306e37FBEd05F7f5bf8',
    BSC_CONTRACT_ADDRESS:'',
    API_BASE_URL:'https://staginglockupbackend.alphaomegacoin.com/api/v1/admin/',
    ENCRYPT_LOCAL_STORAGE: false,
    LOCAL_STORAGE_SECRET: 'D96Q2M84E3400063E8366912AQ45488H',
    ETH_HOLYSKY_TRANSACTION_URL:'https://holesky.etherscan.io/tx/',
    BSC_TRANSACTION_URL:'https://testnet.bscscan.com/tx/',
    SOCKET_BASE_URL: 'https://staginglockupbackend.alphaomegacoin.com/',
    FILE_UPLOAD_URL: 'https://staginglockupbackend.alphaomegacoin.com/api/v1/file-upload/upload',
    PROJECT_ID: 'e9fe22c7e01c9ca402f42488720cd12b',
    CHAIN :bscTestnet,
    MULTISIG_CONTRACT_ADDRESS: '0xE06D7e4Ec45b3aB008b90DaC58f6838bBE56F751',
    networks: {
        ETH: {
            id: 11155111,
            contractAddress: "0x47794A51775dF4C49B89f9280663Be975fA9cbdc", // ETH Testnet
            chain: sepolia,
            abiFile: "contract-locker.json",
            multisigContractAddress: "0xbeBca90f4105EbDfc0939600EC76c069b3B2AA42",
            rpc:"https://worldchain-sepolia.g.alchemy.com/v2/Ehx84XSejJSJRNvl0EqCMokHaTmEEKlP"

        },
        BSC: {
            id: 97,
            contractAddress: "0x83742182c1bd8BA658576A034b7A82587425fE08", // BSC Testnet
            chain: bscTestnet,
            abiFile: "contract-locker.json",
            multisigContractAddress: "0xE06D7e4Ec45b3aB008b90DaC58f6838bBE56F751",
            rpc:"https://bnb-testnet.g.alchemy.com/v2/Ehx84XSejJSJRNvl0EqCMokHaTmEEKlP"
        },
        POLYGON: {
            id: 80002,
            contractAddress: "0xA1781A0cdc1be3509b5F2306e37FBEd05F7f5bf8", // POLYGON Testnet
            chain: polygon,
            abiFile: "contract-locker.json",
            multisigContractAddress: "0x59952eE49399E847fC4550a06911Ca75a637D302",
            rpc:"https://polygon-amoy.g.alchemy.com/v2/Ehx84XSejJSJRNvl0EqCMokHaTmEEKlP"

        }
    } as any,
    chain_id: {//this config api request chain conformation purpose only
        17000: 'ETH',
        97: 'BSC',
        1: 'ETH',
        56: 'BSC',
        80002: 'POLYGON',
        11155111: 'ETH'
    }


};
